module.exports = __webpack_public_path__ + "img/mdcs.00a0f5fd.png";